// extracted by mini-css-extract-plugin
export default {"RemovePart":"styles_RemovePart__HN6oj","RemovePart--btn":"styles_RemovePart--btn__ZJKHr"};